export default __webpack_public_path__ + "static/generative-border-light-6130263b87dd32bd535179de18124358cd561664bf7ad7b9840666ecc963fc70.png";